module.exports = __webpack_public_path__ + "static/media/Mobile-Banner-Activate-ATM-Card.660c5993.jpg";